module.exports = __webpack_public_path__ + "img/ganlanlv.21c49cea.png";